export const PIPELINE_STAGES = [
  {
    key: "acquisitions",
    label: "Acquisitions",
    statuses: [
      { value: "new_lead", label: "New Lead" },
      { value: "contacted", label: "Contacted" },
      { value: "nurture_lead", label: "Nurture Lead" },
      { value: "analyzing_deal", label: "Analyzing Deal" },
      { value: "offer_made", label: "Offer Made" },
      { value: "due_diligence", label: "Due Diligence" },
      { value: "under_contract", label: "Under Contract" },
    ],
  },

  {
    key: "projects",
    label: "Projects",
    statuses: [
      { value: "pre_construction", label: "Pre-Construction" },
      { value: "under_construction", label: "Under Construction" },
      { value: "finishing", label: "Finishing" },
      { value: "completed", label: "Completed" },
    ],
  },

  {
    key: "dispositions",
    label: "Dispositions",
    statuses: [
      { value: "pre_listing", label: "Pre-Listing" },
      { value: "active_listing", label: "Active Listing" },
      { value: "pending", label: "Pending" },
      { value: "sold", label: "Sold" },
    ],
  },
];